import { DonutChart } from './donutChart';

export { DonutChart }